import React from 'react';
import {Tabs, TabList, Tab, TabPanel, TabPanels, Heading, Text, Box, useBreakpointValue} from '@chakra-ui/react';
import CardVertical from '../cards/CardVertical';
import PropTypes from "prop-types";

const TabsComponent = ({tabsInfo}) => {
    const isMobile = useBreakpointValue({base: true, md: false});

    TabsComponent.propTypes = {
        tabsInfo: PropTypes.arrayOf(PropTypes.shape({
            tabTitle: PropTypes.string.isRequired,
            sectionTitle: PropTypes.string.isRequired,
            sectionDescription: PropTypes.string.isRequired,
            verticalCards: PropTypes.arrayOf(PropTypes.shape({
                image: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired
            }))
        })),
    };

    return (
        <Tabs className="column-1-10 column-m-1-4 grid-div-10-col" p="0px">
            <TabList className="column-1-2 column-m-1-4 grid-div-2-col" style={{ width: "fit-content", gap: 0, margin: "0 auto" }}
            >
                {tabsInfo.map((tab, index) => (
                    <Tab className='tabslist-title' key={index}>{tab.tabTitle}</Tab>
                ))}
            </TabList>

            <TabPanels className='column-1-10 grid-div-10-col' p="0px">
                {tabsInfo.map((tab, index) => (
                    <TabPanel key={index} className='column-1-10 grid-div-10-col' p="0px" pt={isMobile ? "59px" : "68px"}>
                        <Box className='column-1-9 grid-div-9-col' p="0px">
                            <Heading className='column-1-6' variant="heading3">
                                {tab.sectionTitle}
                            </Heading>
                            <Text whiteSpace="pre-line" textStyle="customBodyMedium"
                                  className='column-1-6'>{tab.sectionDescription}</Text>
                            <Box mt={isMobile ? 20 : 3} className='column-1-9 grid-div-9-col'>
                                {tab.verticalCards.map((cardData, cardIndex) => (
                                    <CardVertical key={cardIndex} cardData={cardData}/>
                                ))}
                            </Box>
                        </Box>
                    </TabPanel>
                ))}
            </TabPanels>
        </Tabs>
    );
};


export default TabsComponent;